import { VendorInvoicesPage } from "../vendor-invoices.page";
import { useCentralStore } from "../../../store/Central";

export const VendorInvoicesPageConnected = () => {
	const organizationId = useCentralStore((s) => s.organization?.id ?? "");
	return <VendorInvoicesPage organizationId={organizationId} />;
};
